import React from 'react';
import {Link} from 'react-router';
import {connect} from 'react-redux';

import { history } from '../../../store';

import * as color from '../../../constants/colors';

import {passwordValidation} from '../../../utils/itemValidation';

import * as loginActionCreators from '../../../actions/login';
let allActionCreators = Object.assign({}, loginActionCreators);


class InternalResetPassword extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      serverError: null,
      serverSuccess: false,
      requestPending: false,
      password1: '',
      password2: '',
      password1Error: null,
      password2Error: null,
    };
  }

  diamondsNav() {
    this.context.router.push('/diamonds');
  }

  changePassword1(evt) {
    this.setState({ password1: evt.target.value });
  }

  changePassword2(evt) {
    this.setState({ password2: evt.target.value });
  }

  validatePassword1() {
    let passwordError = passwordValidation(this.state.password1);
    if(passwordError === null && this.state.password1 !== '' && this.state.password2 !== '' && this.state.password1 != this.state.password2) {
      passwordError = 'Passwords must match';
    }
    this.setState({ password1Error: passwordError });
  }

  validatePassword2() {
    let passwordError = passwordValidation(this.state.password2);
    if(passwordError === null && this.state.password1 !== '' && this.state.password2 !== '' && this.state.password1 != this.state.password2) {
      passwordError = 'Passwords must match';
    }
    this.setState({ password1Error: passwordError });
  }

  loginNav() {
    this.context.router.push('/login');
  }

  validateAll() {
    let password1Error = passwordValidation(this.state.password1);
    let password2Error = passwordValidation(this.state.password2);
    let passwordMatchError = this.state.password1 == this.state.password2 ? null : 'Passwords must match';

    this.setState({
      password1Error: password1Error,
      password2Error: password2Error === null ? passwordMatchError : password2Error,
    });
    return password1Error === null && password2Error === null && passwordMatchError === null;
  }

  handleRequestPassword(evt) {
    
    if(evt) { evt.preventDefault(); }
    
    if(this.validateAll()) {
      this.setState({
        serverError: null,
        requestPending: true,
      }, () => {
        let resetData = {
          password: this.state.password1,
        }
        this.props.callInternalResetPassword(resetData)
        .then((respData) => {
          // this.diamondsNav();
          console.log(history);
          history.back();
        })
        .catch((errorData) => {
          let errorMessage = errorData.message ? errorData.message : 'Cannot connect to Synchromatik';
          this.setState({
            serverError: errorMessage,
            requestPending: false,
            password1: '',
            password2: '',
          });
        });
      });
    } 
  }

  render() {
    return <div className='InternalResetPassword'>
      <div className='formBodyWrapper'>
        <div className='resetTitle'>{this.state.serverSuccess ? 'Success!' : 'Reset Password'}</div>
        <div className='loginBr'>
          <img src='/img/manageusers/iconline_thinlight2.svg' />
        </div>
        {this.state.serverError ? 
          <div className='externalError'>{this.state.serverError}</div> :
          null
        }
        {this.state.serverSuccess ? 
          <div className='forgotSuccess'>
            <div className='successText'>Your password has been successfully changed.</div>
          </div> :
          <div className='ResponsiveForm'>
            <div className='formRow'>Please enter a new password:</div>
            <div className='formRow'>
              <div className='inputWrapper'>
                <input
                  value={this.state.password1} 
                  onChange={this.changePassword1.bind(this)} 
                  onBlur={this.validatePassword1.bind(this)}
                  errorText={this.state.password1Error}
                  placeholder='**********'
                  floatingLabelText='Password'
                  type='password'
                  floatingLabelFocusStyle={{color: color.DD_PURPLE}}
                  underlineFocusStyle={{borderColor: color.DD_PURPLE}}
                  fullWidth={true} />
              </div>
            </div>
            <div className='formRow'>
              <div className='inputWrapper'>
                <input
                  value={this.state.password2} 
                  onChange={this.changePassword2.bind(this)} 
                  onBlur={this.validatePassword2.bind(this)}
                  errorText={this.state.password2Error}
                  placeholder='**********'
                  floatingLabelText='Re-enter password'
                  type='password'
                  floatingLabelFocusStyle={{color: color.DD_PURPLE}}
                  underlineFocusStyle={{borderColor: color.DD_PURPLE}}
                  fullWidth={true} />
              </div>
            </div>
            <div className='formRow'>
              {this.state.serverSuccess ? 
                <div className={'resetSubmitButton actionButton'} onClick={this.loginNav.bind(this)}>Back to Login</div> :
                <div className={'resetSubmitButton actionButton'} onClick={this.handleRequestPassword.bind(this)}>Reset Password</div>
              }
            </div>
          </div>
        }
      </div>
    </div>;
  }
}
export default InternalResetPassword;

function mapStateToProps(state) {
  return {
    login: state.login,
  };
}

export const InternalResetPasswordContainer = connect(
  mapStateToProps,
  allActionCreators
)(InternalResetPassword);